import { useEmailContext } from '../contexts/EmailContext';

export const useEmail = () => {
    const [emailState] = useEmailContext();
    return emailState;
}; 